import React, { useState } from 'react';
import { Radio, Space } from 'antd';
import I18n from 'i18n-js';
import TicketComments from 'components/ticket-comments';
import TicketRoutes from 'components/ticket-routes';
import { string, shape, number } from 'prop-types';

const STATUSES = [
  { key: 'comments', i18n: 'tickets.detailed_info.comments' },
  { key: 'routes', i18n: 'tickets.detailed_info.routes' },
];

const DetailedInfo = ({
  ticketId = null,
  currentUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
}) => {
  const [selectedDetailedInfoType, setSelectedDetailedInfoType] = useState('comments');

  const handleChange = (e) => {
    setSelectedDetailedInfoType(e.target.value);
  };

  return (
    <>
      <div className="tickets-index-page__ticket-detailed-info">
        <Radio.Group
          value={selectedDetailedInfoType}
          onChange={handleChange}
          className="tickets-detailed-info__presets"
        >
          {STATUSES.map(({ key, i18n }) => (
            <Radio.Button key={key} value={key}>
              <Space align="baseline">
                {I18n.t(i18n)}
              </Space>
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>

      {selectedDetailedInfoType === 'comments' && (
        <TicketComments
          key={ticketId}
          ticketId={ticketId}
          currentUserInfo={currentUserInfo}
        />
      )}

      {selectedDetailedInfoType === 'routes' && (
        <TicketRoutes key={ticketId} ticketId={ticketId} />
      )}
    </>
  );
};

DetailedInfo.propTypes = {
  ticketId: number,
  currentUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
};

export default DetailedInfo;
